import { Step1WritingMode } from '../types/step1Writing';

export function modeLabel(mode?: Step1WritingMode): string {
  if (!mode) return 'Not chosen yet';
  switch (mode) {
    case 'external':
      return 'Written and stored elsewhere';
    case 'upload':
      return 'Uploaded document';
    case 'typed':
      return 'Type it here';
    case 'wizard':
      return 'Guided walkthrough';
    default:
      return 'First Step writing';
  }
}

export function venueLabel(venue: string | undefined): string {
  switch (venue) {
    case 'workshop':
      return 'Workshop';
    case 'home_meeting':
      return 'Home meeting';
    case 'sponsor_only':
      return 'With sponsor only';
    case 'other':
      return 'Other';
    default:
      return '';
  }
}
